import React from "react";
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import CampaniasTabla from './CampaniasTabla.jsx';

const CampaniasListar = () => {
    return (
      <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item active">Listado de Campañas</li>
      </ol>
      <h1 className="page-header">Listado de Campañas <small></small></h1>
      <Panel>
        <PanelHeader>Campañas</PanelHeader>
        <PanelBody>
            <CampaniasTabla />
        </PanelBody>
      </Panel>
    </div>
    );
  };
  export default CampaniasListar;
